import React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { Grid, Grid2, Typography } from "@mui/material";
const Contacto = () => {
  return (
    <Box>
      <Stack spacing={10} style={{ padding: "5%" }}>
        <Typography variant="h3" style={{ textAlign: "center" }}>
          <strong>CONTACTO</strong>
        </Typography>
        <Grid2 container justifyContent="center">
          <Grid2 item xs={12} md={6} lg={6} style={{ textAlign: "center" }}>
            <Stack spacing={3}>
              <Typography variant="h6">
                <strong>E-mail:</strong>
              </Typography>
              <Typography variant="p">ebg.edu.gt</Typography>
              <Typography variant="h6">
                <strong>Teléfono:</strong>
              </Typography>
              <Typography variant="p">+502 2382-7223</Typography>
            </Stack>
          </Grid2>
        </Grid2>
      </Stack>
    </Box>
  );
};

export default Contacto;
